import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/ADF/ADDISON_FASTENERS_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLine } from './components/QuoteLine';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const ADF_SITE_INFORMATION = [
  '196 N. Addison Rd.',
  'Addison, IL 60101',
  'Phone (847) 229-1999',
];

export function ADFQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} />

        <SiteInformation
          name="Addison Fasteners"
          items={ADF_SITE_INFORMATION}
        />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB={true} />
      </QuoteDetails>

      {quoteLines.map((line) => {
        return (
          <QuoteLine key={line.id} {...line} showDrawing>
            <PartId {...line.part} />

            <PartDescription description={line.part.description} />

            <PartSpecs specs={line.specs} />
          </QuoteLine>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>Certification & Testing Disclaimer:</Text>
          <Text style={styles.textSmall}>
            If your order requires any product certifications, special
            documentation, or testing (e.g., material certifications,
            dimensional reports, PPAPs, RoHS/REACH compliance, etc.), you must
            notify your Addison Account Manager at the time of the RFQ or
            purchase order. Additional charges may apply, and pricing for these
            services will be provided upon request.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>DELIVERY:</Text>
          <Text style={styles.textSmall}>
            View Your Order Status & Tracking Online:
          </Text>
          <Text style={styles.textSmall}>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.bold}>TERMS AND CONDITIONS OF SALE</Text>
          <Text style={[styles.textSmall]}>
            Standard terms and conditions can be found on
            www.mwcomponents.com&lt;https://www.mwcomponents.com/mw-industries-terms-and-conditions&gt;
          </Text>
        </View>
      </View>
    </Page>
  );
}
